(function (jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.responsiveTable = {
    attach: function(context, settings) {
      const selector = '.view-id-featured_events.view-display-id-main, .view-id-featured_events_global.view-display-id-main';

      jQuery(context).find(selector).once('featured-events-carousel').each(function() {
        let $thisView = jQuery(this);
        let $sliderContainer = $thisView.find('.view-content');
        const swiper = new Swiper('.view-display-id-main .view-content', {
          slideClass: 'views-row',
          slidesPerView: 1,
          breakpoints: {
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 10
            },
            1000: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 10
            }
          },
          navigation: {
            nextEl: ".button-next",
            prevEl: ".button-prev"
          },
          pagination: {
            el: '.dots',
            clickable: true
          },
          // autoplay: {
          //   delay: 3000
          // }
        });

        var swiperBlazy = new Blazy({
          container: '.view-display-id-main .view-content',
          // offset: offsetX
        });

        swiper.on('slideChange', function () {
          swiperBlazy.revalidate();
        });
      });
    }
  };

})(jQuery, Drupal);
